<div [class.padding-left]="paddingLeft" [class.padding-right]="paddingRight">
    <img src="/assets/svg/logo.svg" />
</div>
